import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data/content";

const BENEFITS = [
  "Diagnóstico de tu comunicación sin compromiso",
  "Recomendaciones concretas para empezar hoy",
  "30 minutos, 100% enfocados en ti",
];

export const Booking = () => {
  useEffect(() => {
    const id = "calendly-widget-script";
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      link.rel = "stylesheet";
      document.head.appendChild(link);

      const script = document.createElement("script");
      script.id = id;
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section id="agendar" className="py-20 md:py-28 bg-[#2b2a33] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5"
        >
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#ffc247]">
            Demos el primer paso
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
            Agenda tu llamada gratuita
          </h2>
          <p className="mt-5 text-lg text-white/60 leading-relaxed">
            Elige el día y la hora que mejor te quede. Conversamos sobre tu situación actual y
            trazamos un plan para conectar, posicionar y crecer.
          </p>

          <ul className="mt-8 space-y-4">
            {BENEFITS.map((b, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-[#ff5c49] flex items-center justify-center shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-white" />
                </span>
                <span className="text-white/80">{b}</span>
              </li>
            ))}
          </ul>

          <a
            href={BRAND.calendly}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="calendly-direct-link"
            className="mt-9 inline-flex items-center gap-2 bg-[#ff5c49] text-white font-semibold px-7 py-4 rounded-full hover:bg-[#e6452f] transition-colors"
          >
            Abrir calendario <ArrowUpRight className="w-5 h-5" />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="lg:col-span-7 w-full"
        >
          <div
            data-testid="calendly-embed"
            className="calendly-inline-widget bg-white rounded-2xl overflow-hidden"
            data-url={`${BRAND.calendly}?hide_gdpr_banner=1&primary_color=ff5c49`}
            style={{ minWidth: "320px", height: "680px" }}
          />
        </motion.div>
      </div>
    </section>
  );
};
